import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FieldConfigState {
  hiddenFields: string[];
  loading: boolean;
  error: string | null;
}

const initialState: FieldConfigState = {
  hiddenFields: [],
  loading: false,
  error: null,
};

const fieldConfigSlice = createSlice({
  name: "fieldConfig",
  initialState,
  reducers: {
    setHiddenFields: (state, action: PayloadAction<string[]>) => {
      state.hiddenFields = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setHiddenFields, setLoading, setError } =
  fieldConfigSlice.actions;
export default fieldConfigSlice.reducer;
